import { getReviewsGlobal } from '@monofront/business/utils';
import { useProduct } from '../ProductCard';
import { useTranslations } from 'next-intl';
import RatingStar from '../../../visuals/Icons/RatingStar';

export const ProductReviews = () => {
  const product = useProduct();
  const tCatalog = useTranslations('Catalog');

  if (!product) {
    return null;
  }
  const { average_rating, count } = getReviewsGlobal(product);

  if (!count || count < 1) {
    return null;
  }

  return (
    <p className="tw-grid-area-[reviews] tw-flex tw-items-end">
      <span className=" tw-flex tw-space-x-1 tw-lf-caption-strong tw-text-black-700">
        <RatingStar aria-hidden="true" />
        <span>
          {tCatalog.rich('ratingReviews', {
            sronly: (children) => (
              <span className="tw-sr-only">{children}</span>
            ),
            rating: average_rating,
          })}{' '}
          (
          {tCatalog('nbReviews', {
            nb: count,
          })}
          )
        </span>
      </span>
    </p>
  );
};
